import { render } from "./KeyValueHeader.vue?vue&type=template&id=b19eb488"
import script from "./KeyValueHeader.vue?vue&type=script&lang=js"
export * from "./KeyValueHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KeyValueHeader.vue"]])

export default __exports__